import { hasPermission, hasRole } from "@/utils/permission";

/**
 * 权限指令
 * 使用方式：
 * v-permission="'course_manage'" - 检查是否有指定权限
 * v-role="'teacher'" - 检查是否有指定角色
 * v-role="['teacher', 'admin']" - 检查是否有指定角色中的任意一个
 */
export default {
  install(Vue) {
    // 权限指令
    Vue.directive("permission", {
      inserted(el, binding, vnode) {
        const { value } = binding;
        const store = vnode.context.$store;
        const userRoles = store.state.roles;

        if (!hasPermission(userRoles, value)) {
          el.parentNode && el.parentNode.removeChild(el);
        }
      },
    });

    // 角色指令
    Vue.directive("role", {
      inserted(el, binding, vnode) {
        const { value } = binding;
        const store = vnode.context.$store;
        const userRoles = store.state.roles;

        if (!hasRole(userRoles, value)) {
          el.parentNode && el.parentNode.removeChild(el);
        }
      },
    });
  },
};
